module.exports = __webpack_public_path__ + "img/P2.bcf67b03.jpg";